(function(window, document) {
  'use strict';

  var STORAGE_KEY = 'rbs:vat-display';
  var INCLUDED = 'included';
  var EXCLUDED = 'excluded';
  var VALID_MODES = { included: true, excluded: true };
  var WSAIO_SELECTOR = [
    '.wsaio_price',
    '.wsaio_priceOriginal',
    '[class*="wsaio"] [class*="price"]',
    '[id*="wsaio"] [class*="price"]',
    '[class*="wsaio"] [data-price]',
    '[class*="wsaio"] td',
    '[class*="wsaio"] span',
    '[id*="wsaio"] span',
    '[class*="wsaio"] .money',
    '.wsaio_saved',
    '.wsaio_saving',
    '[class*="wsaio"] [class*="sav"]'
  ].join(',');
  var WSAIO_CART_ROOT_SELECTOR = [
    '[data-section-type="cart-template"]',
    '.cart_total_price'
  ].join(',');
  var WSAIO_CART_PRICE_SELECTOR = [
    '[data-section-type="cart-template"] .CartItem .money',
    '[data-section-type="cart-template"] .CartItem__PriceList > del',
    '[data-section-type="cart-template"] .CartItem__LinePriceList > del',
    '[data-section-type="cart-template"] [data-cart-subtotal] .money',
    '[data-section-type="cart-template"] [data-cart-subtotal] > del',
    '[data-section-type="cart-template"] [data-cart-discount-wrapper] .money',
    '[data-section-type="cart-template"] [data-cart-discount-amount] .money',
    '.cart_total_price .money',
    '.cart_total_price > del'
  ].join(',');
  var APP_PRICE_SELECTOR = WSAIO_SELECTOR + ',' + WSAIO_CART_PRICE_SELECTOR;
  var GEMPAGES_PRICE_SELECTOR = '.gf_product-price[data-price], .gf_product-compare-price[data-price-compare-at]';
  var wsaioObserver;
  var discoveryObserver;
  var observedPriceRoots = [];
  var wsaioQueued = false;
  var appRefreshTimers = [];
  var stickyVatBar;
  var stickyVisibilityQueued = false;

  window.theme = window.theme || {};

  function validMode(mode) {
    return VALID_MODES[mode] ? mode : INCLUDED;
  }

  function getMode() {
    return validMode(document.documentElement.getAttribute('data-vat-display'));
  }

  function storeMode(mode) {
    try {
      window.localStorage.setItem(STORAGE_KEY, mode);
    } catch (error) {
      // Storage may be unavailable in private or restricted browser contexts.
    }
  }

  function getDisplayCents(grossCents) {
    var cents = Math.round(Number(grossCents) || 0);
    return getMode() === EXCLUDED ? Math.round(cents * 100 / 120) : cents;
  }

  function fallbackFormatMoney(cents, format) {
    var value = (Math.round(Number(cents) || 0) / 100).toFixed(2);
    var formatString = format || '£{{amount}}';
    return formatString
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(Number(cents) / 100)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, String(Math.round(Number(cents) / 100)))
      .replace(/\{\{\s*amount\s*\}\}/, value);
  }

  function formatCents(cents, moneyFormat) {
    var format = moneyFormat || window.theme.vatMoneyFormat || window.theme.moneyFormat;
    if (window.theme.Currency && typeof window.theme.Currency.formatMoney === 'function') {
      return window.theme.Currency.formatMoney(cents, format);
    }
    return fallbackFormatMoney(cents, format);
  }

  function formatDisplayMoney(grossCents, moneyFormat) {
    return formatCents(getDisplayCents(grossCents), moneyFormat);
  }

  function formattedMoneyText(formattedMoney) {
    if (!document.createElement) return String(formattedMoney);
    var container = document.createElement('span');
    container.innerHTML = formattedMoney;
    return container.textContent;
  }

  function priceRoot(element) {
    if (!element) return null;
    if (element.matches && element.matches('[data-vat-price]')) return element;
    return element.querySelector ? element.querySelector('[data-vat-price]') : null;
  }

  function updatePriceElement(element, grossCents, moneyFormat) {
    if (!element) return;
    var cents = Math.round(Number(grossCents) || 0);
    var root = priceRoot(element);

    if (!root) {
      root = document.createElement('span');
      root.setAttribute('data-vat-price', '');
      element.textContent = '';
      element.appendChild(root);
    }

    var format = moneyFormat || root.getAttribute('data-vat-money-format') ||
      window.theme.vatMoneyFormat || window.theme.moneyFormat;
    var included = root.querySelector('[data-vat-included]');
    var excluded = root.querySelector('[data-vat-excluded]');

    if (!included) {
      included = document.createElement('span');
      included.setAttribute('data-vat-included', '');
      root.appendChild(included);
    }
    if (!excluded) {
      excluded = document.createElement('span');
      excluded.setAttribute('data-vat-excluded', '');
      root.appendChild(excluded);
    }
    if (element.hasAttribute && element.hasAttribute('data-vat-structured-price')) {
      included.setAttribute('itemprop', 'price');
    }

    root.setAttribute('data-vat-gross-cents', String(cents));
    if (format) root.setAttribute('data-vat-money-format', format);
    included.innerHTML = formatCents(cents, format);
    excluded.innerHTML = formatCents(Math.round(cents * 100 / 120), format);
    root.setAttribute('data-vat-rendered-included', included.textContent.trim());
  }

  function syncControls() {
    var mode = getMode();
    var included = mode === INCLUDED;
    var label = included ? 'VAT included' : 'VAT excluded';
    document.querySelectorAll('[data-vat-toggle]').forEach(function(control) {
      control.setAttribute('aria-checked', included ? 'true' : 'false');
      control.setAttribute('aria-label', label);
      var labelElement = control.querySelector('[data-vat-toggle-label]');
      if (labelElement) labelElement.textContent = label;
    });
  }

  function getVisibleSourceControl() {
    var controls = document.querySelectorAll('[data-vat-toggle-source]');
    for (var index = 0; index < controls.length; index += 1) {
      var control = controls[index];
      var style = window.getComputedStyle(control);
      if (style.display !== 'none' && style.visibility !== 'hidden' &&
          control.offsetWidth > 0 && control.offsetHeight > 0) {
        return control;
      }
    }
    return null;
  }

  function setStickyBarVisible(visible) {
    if (!stickyVatBar) return;
    var stickyToggle = stickyVatBar.querySelector('[data-vat-toggle]');
    var sourceControls = document.querySelectorAll('[data-vat-toggle-source]');
    stickyVatBar.classList.toggle('is-visible', visible);
    stickyVatBar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    sourceControls.forEach(function(control) {
      if (visible) {
        control.setAttribute('aria-hidden', 'true');
        control.setAttribute('tabindex', '-1');
      } else {
        control.removeAttribute('aria-hidden');
        control.removeAttribute('tabindex');
      }
    });
    if (visible) {
      stickyVatBar.removeAttribute('inert');
      if (stickyToggle) stickyToggle.removeAttribute('tabindex');
    } else {
      if (stickyToggle && document.activeElement === stickyToggle) {
        var sourceControl = getVisibleSourceControl();
        if (sourceControl) sourceControl.focus({ preventScroll: true });
      }
      stickyVatBar.setAttribute('inert', '');
      if (stickyToggle) stickyToggle.setAttribute('tabindex', '-1');
    }
  }

  function updateStickyBarVisibility() {
    stickyVisibilityQueued = false;
    var sourceControl = getVisibleSourceControl();
    setStickyBarVisible(Boolean(
      sourceControl && sourceControl.getBoundingClientRect().bottom <= 0
    ));
  }

  function scheduleStickyBarVisibility() {
    if (stickyVisibilityQueued) return;
    stickyVisibilityQueued = true;
    window.setTimeout(updateStickyBarVisibility, 16);
  }

  function initStickyBar() {
    stickyVatBar = document.querySelector('[data-vat-sticky-bar]');
    if (!stickyVatBar) return;
    window.addEventListener('scroll', scheduleStickyBarVisibility, { passive: true });
    document.addEventListener('scroll', scheduleStickyBarVisibility, {
      passive: true,
      capture: true
    });
    window.addEventListener('resize', scheduleStickyBarVisibility);
    document.addEventListener('shopify:section:load', scheduleStickyBarVisibility);
    scheduleStickyBarVisibility();
  }

  function dispatchModeChange(mode) {
    var event;
    if (typeof window.CustomEvent === 'function') {
      event = new window.CustomEvent('rbs:vat-display-change', { detail: { mode: mode } });
    } else {
      event = document.createEvent('CustomEvent');
      event.initCustomEvent('rbs:vat-display-change', false, false, { mode: mode });
    }
    document.dispatchEvent(event);
  }

  function setMode(mode, options) {
    var nextMode = validMode(mode);
    var previousMode = getMode();
    document.documentElement.setAttribute('data-vat-display', nextMode);
    if (!options || options.persist !== false) storeMode(nextMode);
    syncControls();
    upgrade(document);

    if (previousMode !== nextMode || (options && options.forceEvent)) {
      dispatchModeChange(nextMode);
    }
  }

  function parseMoneyToCents(text) {
    var normalized = String(text || '')
      .replace(/\u00a0/g, ' ')
      .replace(/[^\d.,-]/g, '');
    if (!normalized || !/\d/.test(normalized)) return null;

    var lastDot = normalized.lastIndexOf('.');
    var lastComma = normalized.lastIndexOf(',');
    var decimalIndex = Math.max(lastDot, lastComma);
    var decimalDigits = decimalIndex >= 0 ? normalized.length - decimalIndex - 1 : 0;
    var number;

    if (decimalIndex >= 0 && decimalDigits > 0 && decimalDigits <= 2) {
      number = normalized.slice(0, decimalIndex).replace(/[.,]/g, '') + '.' +
        normalized.slice(decimalIndex + 1).replace(/[.,]/g, '');
    } else {
      number = normalized.replace(/[.,]/g, '');
    }

    var parsed = Number(number);
    return Number.isFinite(parsed) ? Math.round(parsed * 100) : null;
  }

  function splitMoneyText(text) {
    var source = String(text || '');
    var match = source.match(/(?:£\s*|GBP\s*)-?\d[\d,.]*(?:\s*GBP)?/i);
    if (!match) return { prefix: '', money: source, suffix: '' };
    return {
      prefix: source.slice(0, match.index),
      money: match[0],
      suffix: source.slice(match.index + match[0].length)
    };
  }

  function isPriceLeaf(node) {
    if (!node || !node.matches || !node.matches(APP_PRICE_SELECTOR)) return false;
    if (node.closest && node.closest('[data-vat-price]')) return false;
    if (node.querySelector && node.querySelector(APP_PRICE_SELECTOR)) return false;
    var text = node.textContent || '';
    var hasCurrency = /(?:£|GBP)/i.test(text);
    var hasDecimalMoney = /\d[.,]\d{2}/.test(text);
    return hasCurrency || (hasDecimalMoney && !/%/.test(text));
  }

  function updateWsaioNode(node, recapture) {
    if (!isPriceLeaf(node)) return;
    var currentText = (node.textContent || '').trim();
    var lastRendered = node.getAttribute('data-vat-rendered-text');
    var grossAttribute = node.getAttribute('data-vat-app-gross-cents');
    var grossCents = grossAttribute === null ? NaN : Number(grossAttribute);

    if (recapture && currentText !== lastRendered) {
      var parts = splitMoneyText(currentText);
      grossCents = parseMoneyToCents(parts.money);
      node.setAttribute('data-vat-app-prefix', parts.prefix);
      node.setAttribute('data-vat-app-suffix', parts.suffix);
    }
    if (!Number.isFinite(grossCents)) {
      var initialParts = splitMoneyText(currentText);
      grossCents = parseMoneyToCents(initialParts.money);
      node.setAttribute('data-vat-app-prefix', initialParts.prefix);
      node.setAttribute('data-vat-app-suffix', initialParts.suffix);
    }
    if (!Number.isFinite(grossCents)) return;

    var rendered = (node.getAttribute('data-vat-app-prefix') || '') +
      formattedMoneyText(formatDisplayMoney(
        grossCents,
        window.theme.vatMoneyFormat || window.theme.moneyFormat
      )) +
      (node.getAttribute('data-vat-app-suffix') || '');
    node.setAttribute('data-vat-app-gross-cents', String(grossCents));
    node.setAttribute('data-vat-rendered-text', rendered);
    if (currentText !== rendered) node.textContent = rendered;
  }

  function upgradeWsaio(container, recapture) {
    if (!container || !container.querySelectorAll) return;
    if (isPriceLeaf(container)) updateWsaioNode(container, recapture);
    container.querySelectorAll(APP_PRICE_SELECTOR).forEach(function(node) {
      updateWsaioNode(node, recapture);
    });
  }

  function updateGemPagesNode(node) {
    if (!node || !node.matches || !node.matches(GEMPAGES_PRICE_SELECTOR)) return;
    var root = node.querySelector('[data-vat-price]');
    var grossCents;

    if (root) {
      var included = root.querySelector('[data-vat-included]');
      if (!included) return;
      var recordedIncluded = root.getAttribute('data-vat-rendered-included');
      if (recordedIncluded === null) {
        root.setAttribute('data-vat-rendered-included', included.textContent.trim());
        return;
      }
      if (included.textContent.trim() === recordedIncluded) return;
      grossCents = parseMoneyToCents(included.textContent);
    } else {
      grossCents = parseMoneyToCents(node.textContent);
    }

    if (Number.isFinite(grossCents)) {
      updatePriceElement(node, grossCents, window.theme.vatMoneyFormat || window.theme.moneyFormat);
    }
  }

  function upgradeGemPages(container) {
    if (!container || !container.querySelectorAll) return;
    if (container.matches && container.matches(GEMPAGES_PRICE_SELECTOR)) updateGemPagesNode(container);
    container.querySelectorAll(GEMPAGES_PRICE_SELECTOR).forEach(updateGemPagesNode);
  }

  function scheduleWsaioUpgrade() {
    if (wsaioQueued) return;
    wsaioQueued = true;
    window.requestAnimationFrame(function() {
      wsaioQueued = false;
      upgradeWsaio(document, true);
      upgradeGemPages(document);
    });
  }

  function handleObservedPriceMutations(mutations) {
    var relevant = mutations.some(function(mutation) {
      var element = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
      if (!element || !element.closest) return false;
      if (element.closest(WSAIO_CART_ROOT_SELECTOR)) return true;
      var gemPrice = element.closest(GEMPAGES_PRICE_SELECTOR);
      if (gemPrice) {
        var gemRoot = gemPrice.querySelector('[data-vat-price]');
        var gemIncluded = gemRoot && gemRoot.querySelector('[data-vat-included]');
        if (!gemRoot || !gemIncluded ||
            gemIncluded.textContent.trim() !== gemRoot.getAttribute('data-vat-rendered-included')) {
          return true;
        }
      }
      if (element.closest('[data-vat-price]')) return false;

      var price = element.closest(APP_PRICE_SELECTOR);
      if (price && isPriceLeaf(price)) {
        return (price.textContent || '').trim() !== price.getAttribute('data-vat-rendered-text');
      }

      var nestedPrices = element.querySelectorAll(APP_PRICE_SELECTOR);
      for (var index = 0; index < nestedPrices.length; index += 1) {
        if (isPriceLeaf(nestedPrices[index])) return true;
      }
      return false;
    });
    if (relevant) scheduleWsaioUpgrade();
  }

  function observePriceRoots(container) {
    if (!wsaioObserver || !container || !container.querySelectorAll) return;
    var roots = [];

    var rootSelector = '[class*="wsaio"], [id*="wsaio"], ' +
      GEMPAGES_PRICE_SELECTOR + ', ' + WSAIO_CART_ROOT_SELECTOR;

    if (container.matches && container.matches(rootSelector)) {
      roots.push(container);
    }
    container.querySelectorAll(rootSelector)
      .forEach(function(root) {
        roots.push(root);
      });

    roots.forEach(function(root) {
      if (observedPriceRoots.indexOf(root) !== -1) return;
      if (root.matches('[class*="wsaio"], [id*="wsaio"]')) {
        var parentWsaio = root.parentElement &&
          root.parentElement.closest('[class*="wsaio"], [id*="wsaio"]');
        if (parentWsaio) return;
      }
      observedPriceRoots.push(root);
      wsaioObserver.observe(root, { childList: true, characterData: true, subtree: true });
    });
  }

  function initWsaioObserver() {
    if (wsaioObserver || !window.MutationObserver || !document.body) return;
    wsaioObserver = new MutationObserver(function() {
      scheduleWsaioUpgrade();
    });
    observePriceRoots(document);

    discoveryObserver = new MutationObserver(function(mutations) {
      var foundPriceRoot = false;
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          var element = node.nodeType === 1 ? node : node.parentElement;
          if (!element) return;

          var addedPrice = element.closest && element.closest(APP_PRICE_SELECTOR);
          if (addedPrice && isPriceLeaf(addedPrice) &&
              (addedPrice.textContent || '').trim() !==
                addedPrice.getAttribute('data-vat-rendered-text')) {
            foundPriceRoot = true;
          }

          var nestedPrices = element.querySelectorAll ?
            element.querySelectorAll(APP_PRICE_SELECTOR) : [];
          for (var index = 0; index < nestedPrices.length; index += 1) {
            if (isPriceLeaf(nestedPrices[index]) &&
                (nestedPrices[index].textContent || '').trim() !==
                  nestedPrices[index].getAttribute('data-vat-rendered-text')) {
              foundPriceRoot = true;
              break;
            }
          }

          if (node.nodeType !== 1) return;
          var hasPriceRoot = (element.matches &&
            element.matches('[class*="wsaio"], [id*="wsaio"], ' +
              GEMPAGES_PRICE_SELECTOR + ', ' + WSAIO_CART_ROOT_SELECTOR)) ||
            (element.querySelector && element.querySelector(
              '[class*="wsaio"], [id*="wsaio"], ' +
              GEMPAGES_PRICE_SELECTOR + ', ' + WSAIO_CART_ROOT_SELECTOR
            ));
          if (!hasPriceRoot) return;
          foundPriceRoot = true;
          observePriceRoots(element);
        });
      });
      if (foundPriceRoot) scheduleWsaioUpgrade();
      handleObservedPriceMutations(mutations);
    });
    discoveryObserver.observe(document.body, { childList: true, subtree: true });
  }

  function grossToDisplayMajor(grossMajor) {
    var grossCents = Math.round((Number(grossMajor) || 0) * 100);
    return getDisplayCents(grossCents) / 100;
  }

  function displayToGrossMajor(displayMajor) {
    var value = Number(displayMajor) || 0;
    return getMode() === EXCLUDED ? Math.round(value * 120) / 100 : value;
  }

  function syncPriceFilters(container) {
    if (!container || !container.querySelectorAll) return;
    container.querySelectorAll('.filter-group-display__price-range-input').forEach(function(input) {
      if (!input.hasAttribute('data-vat-gross-value')) {
        var initial = input.value || input.placeholder || '0';
        input.setAttribute('data-vat-gross-value', String(parseFloat(initial.replace(/[^\d.-]/g, '')) || 0));
      }
      var gross = Number(input.getAttribute('data-vat-gross-value')) || 0;
      var displayed = grossToDisplayMajor(gross);
      if (input.value) input.value = String(displayed);
      if (input.placeholder) {
        var grossPlaceholder = input.getAttribute('data-vat-gross-placeholder');
        if (!grossPlaceholder) {
          grossPlaceholder = String(parseFloat(input.placeholder.replace(/[^\d.-]/g, '')) || 0);
          input.setAttribute('data-vat-gross-placeholder', grossPlaceholder);
        }
        input.placeholder = String(grossToDisplayMajor(grossPlaceholder));
      }
    });
  }

  function preparePriceFilterForm(form) {
    if (!form || getMode() !== EXCLUDED) return;
    form.querySelectorAll('.filter-group-display__price-range-input').forEach(function(input) {
      if (!input.value) return;
      input.value = String(displayToGrossMajor(input.value));
    });
  }

  function upgrade(container) {
    var scope = container || document;
    if (scope.matches && scope.matches('[data-vat-price][data-vat-gross-cents]') &&
        (!scope.querySelector('[data-vat-included]') || !scope.querySelector('[data-vat-excluded]'))) {
      updatePriceElement(scope, scope.getAttribute('data-vat-gross-cents'));
    }
    if (scope.querySelectorAll) {
      scope.querySelectorAll('[data-vat-price][data-vat-gross-cents]').forEach(function(element) {
        if (!element.querySelector('[data-vat-included]') ||
            !element.querySelector('[data-vat-excluded]')) {
          updatePriceElement(element, element.getAttribute('data-vat-gross-cents'));
        }
      });
    }
    syncPriceFilters(scope);
    upgradeWsaio(scope, false);
    upgradeGemPages(scope);
    observePriceRoots(scope);
  }

  function refreshAfterApp(container) {
    appRefreshTimers.forEach(function(timer) {
      window.clearTimeout(timer);
    });
    appRefreshTimers = [];

    function refresh() {
      var scope = container || document;
      if (scope !== document && !document.documentElement.contains(scope)) {
        scope = document;
      }
      upgradeWsaio(scope, true);
      upgradeGemPages(scope);
      observePriceRoots(scope);
    }

    refresh();
    [100, 500, 1500, 3000].forEach(function(delay) {
      appRefreshTimers.push(window.setTimeout(refresh, delay));
    });
  }

  window.theme.VatDisplay = {
    getMode: getMode,
    setMode: setMode,
    getDisplayCents: getDisplayCents,
    formatDisplayMoney: formatDisplayMoney,
    updatePriceElement: updatePriceElement,
    syncControls: syncControls,
    upgrade: upgrade,
    refreshAfterApp: refreshAfterApp,
    preparePriceFilterForm: preparePriceFilterForm,
    displayToGrossMajor: displayToGrossMajor
  };

  document.addEventListener('click', function(event) {
    var toggle = event.target.closest && event.target.closest('[data-vat-toggle]');
    if (!toggle) return;
    setMode(getMode() === INCLUDED ? EXCLUDED : INCLUDED);
  });

  document.addEventListener('submit', function(event) {
    if (event.target.querySelector && event.target.querySelector('.filter-group-display__price-range-input')) {
      preparePriceFilterForm(event.target);
    }
  }, true);

  document.addEventListener('input', function(event) {
    var input = event.target;
    if (!input.classList || !input.classList.contains('filter-group-display__price-range-input')) return;
    var grossValue = getMode() === EXCLUDED ? displayToGrossMajor(input.value) : Number(input.value);
    if (Number.isFinite(grossValue)) input.setAttribute('data-vat-gross-value', String(grossValue));
  });

  window.addEventListener('storage', function(event) {
    if (event.key !== STORAGE_KEY) return;
    setMode(validMode(event.newValue), { persist: false });
  });

  function init() {
    syncControls();
    upgrade(document);
    initWsaioObserver();
    initStickyBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', function() {
    initWsaioObserver();
    refreshAfterApp(document);
  });
})(window, document);
